<ion-grid class="stepper-container" [class.stepper-two-steps]="!showStep3">

  <!-- STEP 1 -->
  <ion-col class="step ion-no-padding" [ngClass]="{'completed': currentStep > 1, 'active': currentStep === 1}">
    <div class="circle" translate>RECTIFY_STEPPER_CIRCLE_1</div>
    <span class="title" translate>RECTIFY_STEPPER_CIRCLE_2</span>
    <span class="subtitle" translate>RECTIFY_STEPPER_CIRCLE_3</span>
  </ion-col>

  <ion-col class="line ion-no-padding"></ion-col>

  <!-- STEP 2 -->
  <ion-col class="step ion-no-padding" [ngClass]="{'completed': currentStep > 2, 'active': currentStep === 2}">
    <div class="circle" translate>RECTIFY_STEPPER_CIRCLE_4</div>
    <span class="title" translate>RECTIFY_STEPPER_CIRCLE_5</span>
    <span class="subtitle">{{ step2SubtitleKey | translate }}</span>
  </ion-col>

  <ng-container *ngIf="showStep3">
    <ion-col class="line ion-no-padding"></ion-col>

    <ion-col class="step ion-no-padding" [ngClass]="{'active': currentStep === 3}">
      <div class="circle" translate>RECTIFY_STEPPER_CIRCLE_7</div>
      <span class="title" translate>RECTIFY_STEPPER_CIRCLE_8</span>
      <span class="subtitle" translate>RECTIFY_STEPPER_CIRCLE_9</span>
    </ion-col>
  </ng-container>

</ion-grid>